module.exports = require("lodash.isobject");